import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

const HeaderNavLink = ({ to, children, isMobile = false, setMenuOpen }) => {
  const baseClasses = isMobile 
    ? 'block w-full text-left px-4 py-3 rounded-md text-base font-medium' 
    : 'px-3 py-2 rounded-md text-sm font-semibold tracking-wide';
  
  const activeClasses = isMobile 
    ? 'bg-sky-600 text-white' 
    : 'bg-sky-100 dark:bg-sky-700 text-sky-700 dark:text-white scale-105';
  
  const inactiveClasses = isMobile 
    ? 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700' 
    : 'text-gray-500 dark:text-gray-300 hover:text-sky-600 dark:hover:text-white hover:bg-sky-50 dark:hover:bg-gray-700/50';

  return (
    <RouterNavLink
      to={to}
      onClick={() => {
        if (setMenuOpen) setMenuOpen(false);
      }}
      className={({ isActive }) => 
        `${baseClasses} transition-all duration-200 ease-in-out ${isActive ? activeClasses : inactiveClasses}`
      }
    >
      {children}
    </RouterNavLink>
  );
};

export default HeaderNavLink;
